const STEPS = [
  {
    num: "01",
    title: "The Shoot",
    sub: "You bring the footage.",
    body: "Your latest campaign. Your director cut. All we need is the footage that already exists.",
  },
  {
    num: "02",
    title: "The Cutdowns",
    sub: "We build the variants.",
    body: "20 unique ads per month. Different hooks, different pacing, different audiences.",
  },
  {
    num: "03",
    title: "The Legs",
    sub: "Your campaign travels.",
    body: "New audiences through new versions of the story you already told.",
  },
];

export default function Approach() {
  return (
    <section id="approach" data-testid="approach-section" className="approach-section">
      <div className="approach-inner">
        <div className="approach-head">
          <h2 className="approach-title">
            From one shoot,<br />
            <em>twenty cutdowns.</em>
          </h2>
          <p className="approach-subline">Three steps. It&apos;s actually quite simple.</p>
        </div>

        <ol className="approach-cards" aria-label="How it works">
          {STEPS.map((step) => (
            <li key={step.num} className="approach-card" data-testid={`approach-step-${step.num}`}>
              <p className="approach-card-kicker">
                {step.num} <span aria-hidden>·</span> {step.title}
              </p>
              <p className="approach-card-sub">{step.sub}</p>
              <p className="approach-card-body">{step.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
